<template>
  <v-row >
    <FrontpageSettingsInfoDialog ref="frontpageSettingsInfoDialog"></FrontpageSettingsInfoDialog>
    <v-col >
      <div class="pb-5 d-flex">
        <span class="display-1 pt-1 font-weight-bold">
          {{
          $t("frontpageSettings.general.Frontpage feeds")
          }}
        </span>
        <span>
          <v-btn
            :title="
              $t('frontpageSettings.general.Click to see more information')
            "
            @click.stop="$refs.frontpageSettingsInfoDialog.openDialog()"
            icon
            large
          >
            <v-icon color="primary">far fa-question-circle</v-icon>
          </v-btn>
        </span>
      </div>
      
      <v-divider></v-divider>
      <v-divider></v-divider>

      <!-- <pre>{{CombineNewAndExistingProfiles}}</pre> -->
      <v-tabs
        grow
        @change="
          tab => {
            this.CurrentIndex = tab;
          }
        "
      >
        <v-tab
          v-for="profile in CombineNewAndExistingProfiles"
          :key="profile.id"
        >{{profile.Name || $t("frontpageSettings.tabs.New Frontpage profile")}}</v-tab>
        <v-tab-item v-for="profile in CombineNewAndExistingProfiles" :key="profile.id">

          <v-form @submit.prevent="submitForm">
            <input type="hidden" name="CurrentId" :value="profile.id" />

            <v-row style="background-color: #EEEEEE">
              
              <!--Profile name-->
              <v-col xl="12" lg="12" md="12" sm="12" xs="12" >
                <v-text-field
                  :label="$t('frontpageSettings.form.Name of profile')"
                  v-model="profile.Name"
                ></v-text-field>
              </v-col>
              
            </v-row>
            <v-row style="background-color: #EEEEEE">
              
              <!--Geo tags-->
              <v-col xl="6" lg="6" md="6" sm="12" xs="12">
                <v-autocomplete
                  :label="$t('frontpageSettings.form.GeoTagging')"
                  v-model="profile.GeoTags"
                  :items="profile.Geo.SearchTags"
                  :loading="profile.Geo.IsLoading"
                  :search-input.sync="profile.Geo.Search"
                  item-text="Label"
                  item-value="id"
                  autocomplete
                  multiple
                  chips
                  return-object
                  @change="selectedGeoEvent"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :selected="data.selected"
                      close
                      class="chip--select-multi"
                      @click:close="removeGeoTag(data.item)"
                      @input="removeGeoTag(data.item)"
                    >#{{ data.item.Label }}</v-chip>
                  </template>
                  <template v-slot:item="data">
                    <v-row>
                      <v-col cols="5">
                        <div class="headline">#{{ data.item.Label }}</div>
                      </v-col>
                      <v-col cols="7">
                        <v-row>
                          <v-col cols="12">
                            <span class="body-1" v-text="data.item.Path"></span>
                          </v-col>
                          <v-col cols="12">
                            <span class="caption" v-text="data.item.Category"></span>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </template>
                </v-autocomplete>
              </v-col>

              <!--Tags-->
              <v-col xl="6" lg="6" md="6" sm="12" xs="12" >
                <v-autocomplete
                  :label="$t('frontpageSettings.form.Tagging')"
                  v-model="profile.Tags"
                  :items="TagsOrdered"
                  :loading="profile.Tag.IsLoading"
                  :search-input.sync="profile.Tag.Search"
                  item-text="Label"
                  item-value="id"
                  autocomplete
                  multiple
                  chips
                  return-object
                  @change="selectedTagEvent"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      :selected="data.selected"
                      close
                      class="chip--select-multi"
                      @click:close="removeTag(data.item)"
                      @input="removeTag(data.item)"
                    >#{{ data.item.Label }}</v-chip>
                  </template>
                  <template v-slot:item="data">
                    <v-row>
                      <v-col cols="12">
                        <div class="headline">#{{ data.item.Label }}</div>
                      </v-col>
                    </v-row>
                  </template>
                </v-autocomplete>
              </v-col>

            </v-row>

            <v-row style="background-color: #EEEEEE">
              <v-col xl="6" lg="6" md="6" sm="6" xs="6">
                <v-btn type="submit" color="success" class="mr-3">
                  {{
                  profile.id
                  ? $t("frontpageSettings.general.Update")
                  : $t("frontpageSettings.general.Save and Create")
                  }}
                </v-btn>
                <v-btn
                  type="button"
                  class="warning"
                  @click="deleteTagProfile"
                  v-if="profile.id"
                >{{ $t("frontpageSettings.general.Delete") }}</v-btn>
              </v-col>
            </v-row>


          </v-form>
        </v-tab-item>
      </v-tabs>
    </v-col>

  </v-row>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import messages from "./modules/lang/main/export";
import FrontpageSettingsInfoDialog from "@/components/informational_dialogs/private/frontpageSettings_info_dialog.vue";
export default {
  i18n: {
    messages,
  },
  components: {
    FrontpageSettingsInfoDialog,
  },
  data() {
    return {
      frontpageSettingsInfoDialog: false,
      CurrentIndex: 0,
      CurrentFormData: {
        id: 0,
        Name: "",
        GeoTags: [],
        Tags: [],
        Geo: {
          SearchTags: [],
          SearchTimeout: null,
          IsLoading: false,
          Search: "",
        },
        Tag: {
          SearchTags: [],
          SearchTimeout: null,
          IsLoading: false,
          Search: "",
        },
      },
    };
  },
  watch: {
    CurrentIndex(newVal, oldVal) {
      // console.log(`Currentindex changed from ${oldVal} to ${newVal}`);
    },
    // CombineNewAndExistingProfiles: {
    //   deep: true,
    //   handler(val) {
    //     console.log("watcher", val);
    //   }
    // }
    CurrentGeoSearchTextField(newVal) {
      // if (this.Geo.IsLoading) return;
      if (newVal) {
        this.CombineNewAndExistingProfiles[
          this.CurrentIndex
        ].Geo.IsLoading = true;
        clearTimeout(
          this.CombineNewAndExistingProfiles[this.CurrentIndex].Geo
            .SearchTimeout
        );
        this.CombineNewAndExistingProfiles[
          this.CurrentIndex
        ].Geo.SearchTimeout = setTimeout(() => {
          this.SEARCH_GEO_SUGGESTION(newVal)
            .then((resp) => {
              let _newSearchTagArray = resp.data.concat(
                this.CombineNewAndExistingProfiles[this.CurrentIndex].GeoTags
              );
              this.CombineNewAndExistingProfiles[
                this.CurrentIndex
              ].Geo.SearchTags = _newSearchTagArray;
            })
            .catch((ex) => console.log(ex))
            .finally(() => {
              this.CombineNewAndExistingProfiles[
                this.CurrentIndex
              ].Geo.IsLoading = false;
            });
        }, 1000);
      } else {
        // this.CombineNewAndExistingProfiles[
        //   this.CurrentIndex
        // ].Geo.SearchTags = this.CombineNewAndExistingProfiles[
        //   this.CurrentIndex
        // ].GeoTags;
      }
    },
  },
  computed: {
    CurrentGeoSearchTextField() {
      return this.CombineNewAndExistingProfiles[this.CurrentIndex].Geo.Search;
    },
    CurrentTagSearchTextField() {
      return this.CombineNewAndExistingProfiles[this.CurrentIndex].Tag.Search;
    },

    CombineNewAndExistingProfiles() {
      return [this.CurrentFormData].concat(
        this.TagProfiles.filter((el) => el.id)
      );
    },
    ...mapGetters(["getTags", "TagProfiles"]),
    TagsOrdered() {
      // let _Tags = this.getLanguages.filter(tag => tag.Depth > 1);
      let _Tags = this.getTags;
      if (_Tags && _Tags.length > 0) {
        return _Tags.map((tag) => {
          return {
            ...tag,
            Label: tag.TranslatedLabel ? tag.TranslatedLabel : tag.Label,
          };
        });
      } else {
        return [];
      }
    },
    //     ...mapGetters(["getUser", "GeoTags", "MainTags", "UserArticles"])
  },
  methods: {
    submitForm() {
      let TransferType = "add";
      if (this.CurrentIndex > 0) {
        TransferType = "update";
      }
      let _SubmitData = {
        TransferType,
        ProfileId: this.CombineNewAndExistingProfiles[this.CurrentIndex].id,
        ProfileName: this.CombineNewAndExistingProfiles[this.CurrentIndex].Name,
        GeoInterests: this.CombineNewAndExistingProfiles[
          this.CurrentIndex
        ].GeoTags.map((res) => res.id),
        UserInterests: this.CombineNewAndExistingProfiles[
          this.CurrentIndex
        ].Tags.map((res) => res.id),
      };
      if (_SubmitData.ProfileName == "") {
        this.$emit(
          "snackbarevent",
          `${"Missing info"}: ${this.$t("Name of profile")}`
        );
      } else {
        this.UPDATE_TAGPROFILES(_SubmitData).then(() => {
          this.$emit("snackbarevent", "Tag profiles updated");
          this.resetCreateForm();
          this.GET_TAGPROFILES().then(() => {
            this.$emit("snackbarevent", "new data received");
          });
        });
      }
    },
    resetCreateForm() {
      this.CurrentFormData.Name = "";
      this.CurrentFormData.GeoTags = [];
      this.CurrentFormData.Tags = [];
    },
    deleteTagProfile() {
      let _confirm = confirm(this.$i18n.t("ConfirmDeleteTagProfile"));
      if (_confirm) {
        let TransferType = "delete";
        let _SubmitData = {
          TransferType,
          ProfileId: this.CombineNewAndExistingProfiles[this.CurrentIndex].id,
        };
        this.UPDATE_TAGPROFILES(_SubmitData).then(() => {
          this.$emit("snackbarevent", "Tag profiles updated");
          this.GET_TAGPROFILES().then(() => {
            this.$emit("snackbarevent", "new data received");
          });
        });
      }
    },
    selectedGeoEvent(evt) {
      // this.CombineNewAndExistingProfiles[this.CurrentIndex].Geo.Search = "";
    },
    selectedTagEvent(evt) {
      // this.CombineNewAndExistingProfiles[this.CurrentIndex].Tag.Search = "";
    },
    ...mapActions([
      "SEARCH_GEO_SUGGESTION",
      "GET_TAGPROFILES",
      "UPDATE_TAGPROFILES",
    ]),
    removeGeoTag(item) {
      this.CombineNewAndExistingProfiles[
        this.CurrentIndex
      ].GeoTags = this.CombineNewAndExistingProfiles[
        this.CurrentIndex
      ].GeoTags.filter((geo) => geo.id != item.id);
    },
    removeTag(item) {
      this.CombineNewAndExistingProfiles[
        this.CurrentIndex
      ].Tags = this.CombineNewAndExistingProfiles[
        this.CurrentIndex
      ].Tags.filter((geo) => geo.id != item.id);
    },
  },
  mounted() {
    // this.GET_TAGPROFILES();
  },

};
</script>